import React from 'react';

import PropTypes from 'prop-types';

import ListPart from '../ListPart/ListPart';

function ListBody(props) {
    return (
        <ListPart
            {...props}
        />
    );
}

ListBody.propTypes = {
    /**
     * Sets the align-self property to control the vertical positioning
     */
    align: PropTypes.oneOf(['center', 'end', 'start']),
    /**
     * The content of the list body.
     */
    children: PropTypes.node,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * The component used for the root node.
     * Either a string to use a HTML element or a component.
     */
    component: PropTypes.elementType,
    /**
     * Sets the justify-content property to control the horizontal positioning
     */
    justify: PropTypes.oneOf(['center', 'end', 'start']),
};

export default ListBody;
